import ObjectUtils from '@cb/common-ts/ObjectUtils';
import GqlClient from '@cb/common-ts/GqlClient';
export default class EntityService {
    fetchClient;
    gqlClient;
    registerCancel;
    entityName = 'Entity';
    constructor(gqlClient, fetchClient, registerCancel) {
        this.fetchClient = fetchClient;
        this.gqlClient = gqlClient;
        //new GqlClient({ endpoint: 'api/graphql', fetchClient: this.fetchClient });
        this.registerCancel = registerCancel;
    }
    getBaseUrl() {
        return `entity/${this.entityName}Entity/`;
    }
    create(entity) {
        return this.fetchClient.postJson(this.getBaseUrl(), entity);
    }
    read(id) {
        return this.fetchClient.getJson(`${this.getBaseUrl()}${id}`);
    }
    update(entity) {
        return this.fetchClient.putJson(`${this.getBaseUrl()}`, entity);
    }
    delete(id) {
        return this.fetchClient.delete(`${this.getBaseUrl()}${id}`);
    }
    async gqlPartialCreate(mutation, entity) {
        const variables = {
            data: [entity],
        };
        const request = this.gqlClient.execute(mutation, variables);
        const response = await request.response;
        return this.pullFirstFromMutationResult(response.data);
    }
    async gqlPartialUpdate(mutation, entity, fieldsToUpdate) {
        const variables = {
            data: [entity],
            fieldsToUpdate: fieldsToUpdate ?? ObjectUtils.keysWithDefinedValues(entity),
            forceRefetch: true,
        };
        const request = this.gqlClient.execute(mutation, variables);
        const response = await request.response;
        return this.pullFirstFromMutationResult(response.data);
    }
    pullFirstFromMutationResult(data) {
        if (data.data && data.data.length > 0) {
            return data.data[0];
        }
        throw new Error('Failed to update.');
    }
    graphqlQuery(options) {
        const request = this.gqlClient.execute(options.query, options.variables);
        return {
            data: request.response.then((result) => result.data),
            cancel: request.abort,
        };
    }
    paginatedGraphqlQuery(options) {
        const gqlClient = new GqlClient({ endpoint: 'graphql', fetchClient: this.fetchClient });
        const pagination = {
            total: 0,
            loadNextPage: () => {
                return this.paginatedGraphqlQuery({
                    ...options,
                    variables: {
                        ...options.variables,
                        skip: options.variables.skip + options.variables.take,
                    },
                });
            },
        };
        const request = gqlClient.execute(options.query, options.variables);
        return {
            data: request.response.then((result) => {
                pagination.total = result.data.total?.number ?? 0;
                return result.data.data;
            }),
            pagination,
            cancel: request.abort,
        };
    }
}
export const LoadNextPageNoOp = () => {
    return {
        data: Promise.resolve([]),
        cancel: () => {
            // no-op
        },
        pagination: {
            total: 0,
            loadNextPage: (LoadNextPageNoOp),
        },
    };
};
export const IsGqlResponse = (response) => {
    return response.data !== undefined;
};
export const IsPaginatedResponse = (response) => {
    return response.pagination !== undefined;
};
export class EntityServiceRequestError extends Error {
    type;
    constructor(message, type) {
        super(message);
        this.type = type;
    }
}
export const defaultEntityTake = 25;
//# sourceMappingURL=EntityService.js.map